
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { amountFormatUse, getToken, IsModemAccess } from '../../../helpers/Helper';
import { post } from '../../../helpers/api_helper';
import { POST_PLAN_LIST, POST_UPDATE_PLAN_STATUS } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";


const UserRoles = (props) => {
    const navigate = useNavigate();

    useMounted(() => {
        get_user()
    })

    const get_user = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [7,8] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_PLAN_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "planId" },
                    { "data": "name" },
                    { "data": "code" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {amountFormatUse(data.monthlyPrice)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {amountFormatUse(data.annualPrice)}
                            </>)
                        }
                    },
                    { "data": "freeDay" },
                    { "data": "totalEmployees" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button onClick={UpdateStatus.bind(this, data.planId, data.status)} className={`border-0 badge ${(data.status === 'Active') ? 'bg-success' : 'bg-danger'}`}>{data.status}</button>
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {IsModemAccess('subscription_plan', 'edit') && <> <button className="btn btn-sm text-primary mr-2" onClick={() => { navigate('/admin/subscription-plan/edit/' + data.planId); }} ><i className="bx bx-edit"></i></button> </>}
                            </>)
                        }
                    },
                ]
            });
        }
    }

    //UpdateStatus
    const UpdateStatus = async (planId, status) => {
        if (!IsModemAccess('subscription_plan', 'edit')) {
            toast.error('Does not permission this module');
            return;
        }
        var res_data = await post(POST_UPDATE_PLAN_STATUS, { planId: planId, status: status });
        if (res_data.status) {
            toast(res_data.message);
            get_user();
        } else {
            toast.error(res_data.message);
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Subscription Plans</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    {IsModemAccess('subscription_plan', 'add') && <Link to='/admin/site/add' className='btn btn-sm btn-primary'>+ Add</Link>}
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                {IsModemAccess('subscription_plan', 'view') &&
                                    <table id="dataTableExample" className="table table-striped">
                                        <thead>
                                            <tr>
                                                <td>Id</td>
                                                <td>Name</td>
                                                <td>Code</td>
                                                <td>Monthly Price</td>
                                                <td>Annual Price</td>
                                                <td>Free Day</td>
                                                <td>Employees </td>
                                                <td>Status</td>
                                                <td>Action</td>
                                            </tr>
                                        </thead>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </>
    );
}

export default UserRoles;